import gql from 'graphql-tag';

export const DebtStatusListQuery = gql`
  query debtStatusList {
    debtStatusList {
      id
      kod
      popis
      is_exekuce
      view
    }
  }
`;
